<template>
  <div class="company-access-page">
    <div class="page-title-bar">
      <h1 class="page-title">Company Access</h1>
    </div>
    <div class="page-content">
      <v-card class="content-card" elevation="0">
        <RfUserCompanyAccessList />
      </v-card>
    </div>
  </div>
</template>

<script setup>
import RfUserCompanyAccessList from "@/components/RfSettings/RfUserCompanyAccessList.vue";
</script>

<style scoped>
.company-access-page {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.page-title-bar {
  background-color: white;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #e0e0e0;
}

.page-title {
  font-size: 1.75rem;
  font-weight: 600;
  margin: 0;
  color: #212121;
}

.page-content {
  padding: 2rem;
}

.content-card {
  background-color: white;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}
</style>
